import { Component, OnInit } from "@angular/core";
import { AdminService } from "../service/admin.service";
import { Router } from "@angular/router";

@Component({
    selector: 'app-footer',
    template: require('./footer.component.html'),
    styles: [require('./footer.component.css')]
})
export class FooterComponent {
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/footer/footer.component.ts